export enum ReferralType {
  specialty = 'Specialty',
  imaging = 'Advanced Imaging',
  urgentcare = 'Urgent Care/Emergency',
}

export type ReferralTypeKeys = keyof typeof ReferralType;
